$(document).ready(function() {

    loadKmaCookies();
    $('.kmacookies-save').click(function() {
        saveKmaCookies();
    })

    $('.kmacookies-all').click(function() {
        $('.kmacookies-option').prop("checked", true);
        $('.kmacookies-save').click();
    })



    $('.kmacookies-open').click(function() {
        openKmaCookiesBanner();
    })


})


function openKmaCookiesBanner() {
    $('.kmacookies-banner-wrap').fadeIn(500);
    $('body').addClass('kmacookies-noscroll');
}
function closeKmaCookiesBanner() {
    $('.kmacookies-banner-wrap').fadeOut(500);
    $('body').removeClass('kmacookies-noscroll');
}
function deleteKmaCookies() {
    var cookies = document.cookie.split(";");

    console.log('Lösche Cookies');

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

function saveKmaCookies() {

    console.log('Save');

    $('.kmacookies-option').each(function(r) {
        var fctname=$(this).data('check');

        if ($(this).is(':checked')) {
            window[fctname]();
            $.cookie(fctname, '1', { expires: 365, path: '/' });
        }
        else{
            $.cookie(fctname, '0', { expires: 365, path: '/' });

            //deleteKmaCookies();

        }
    })
    $.cookie('kmaCookiesSaved', '1', { expires: 365, path: '/' });

        var oldMsg= $('.kmacookies-save').html();
        var msg=$('.kmacookies-save').data('save-msg');
        $('.kmacookies-save').text(msg);

    setTimeout(function() {
        closeKmaCookiesBanner();
        $('.kmacookies-save').text(oldMsg);
    },1000);

}


function loadKmaCookies() {


    if (!$.cookie('kmaCookiesSaved')=='1') {
        openKmaCookiesBanner();
    }


    $('.kmacookies-option').each(function() {
        var fctname=$(this).data('check');

        if ($.cookie(fctname)=='1') { // Erlaubt
            window[fctname]();
            $(this).attr('checked',true)
        }
        else if ($.cookie(fctname)=='0') { // Verboten

        }
        else
        {
            $(this).attr('checked',true) // Noch keine Auswahl getroffen
        }
    })
}